import React, { Fragment } from 'react';
import { all_states, dhis_steps } from '../abha/util';
import { Steps } from 'antd';
import { cautionIconFilled, tickIcon2 } from '../common/Icons';
import { IncentiveIssues, dhis_states } from '../../api/getAbhaMetricsDashboard';

const IncentiveSteps: React.FC<{
    currMonthStatus?: {
        status?: all_states;
        month?: string;
        amount?: number;
        issue?: IncentiveIssues;
        dhisstatus?: dhis_states;
        dhisissues?: IncentiveIssues;
    };
    dhisStatus?: dhis_states;
}> = ({ currMonthStatus, dhisStatus }) => {
    return !currMonthStatus ? null : (
        <Fragment>
            <Steps current={1} className="w-50p" size="small">
                {dhis_steps(currMonthStatus, dhisStatus).map((step) => (
                    <Steps.Step
                        status={step.status}
                        icons={{
                            error: (
                                <div className="rounded-full flex justify-center items-center">
                                    {cautionIconFilled('w-20 h-20')}
                                </div>
                            ),
                            finish: (
                                <div className="rounded-full h-full w-full flex justify-center items-center">
                                    {tickIcon2('w-20 h-20 fill-darwin-green-primary font-700')}
                                </div>
                            ),
                        }}
                        key={step.id}
                        title={
                            <p
                                className={`${
                                    step.status === 'finish' || step.status === 'wait'
                                        ? 'font-400'
                                        : 'font-700'
                                } text-14`}
                            >
                                {step.name}
                            </p>
                        }
                    />
                ))}
            </Steps>
            <style>
                {`
                          .ant-steps-item-finish .ant-steps-item-icon {
                            border: none !important;
                          }

                          .ant-steps-item-error .ant-steps-item-icon {
                            border: none !important;
                          }

                          .ant-steps-item-icon, .ant-steps-item, .ant-steps-item-container {
                            display: flex;
                            align-items: center;
                          }

                          .ant-steps-item-icon {
                            justify-content: center;
                          }

                          .ant-steps-item-process .ant-steps-item-icon {
                            border: 1px solid black;
                            background: white !important;
                          }

                          .ant-steps-item-process .ant-steps-icon {
                            color: black !important;
                            font-weight: 700;
                          }
                        `}
            </style>
        </Fragment>
    );
};

export default IncentiveSteps;
